// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-a70e3606] {\n  margin-top: 24px;\n  justify-content: center;\n}\n.flex > *[data-v-a70e3606] {\n  min-width: 80%;\n  margin: 8px;\n}\n.flex .add-product-btn[data-v-a70e3606] {\n  align-self: flex-end;\n  margin-bottom: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
